import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "hero",
  class: "hero-wrap style2"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row gx-5 align-items-center" }
const _hoisted_4 = { class: "col-lg-6 col-md-9" }
const _hoisted_5 = { class: "hero-content" }
const _hoisted_6 = { class: "hero-btn" }
const _hoisted_7 = {
  key: 0,
  class: "popup-video"
}
const _hoisted_8 = { class: "d-table" }
const _hoisted_9 = { class: "d-table-cell" }
const _hoisted_10 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Carousel, {
        autoplay: 5000,
        "items-to-show": 1,
        "wrap-around": true,
        "pause-autoplay-on-hover": "",
        class: "hero-slider-one"
      }, {
        addons: _withCtx(() => [
          _createVNode(_component_Navigation)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slider, (index, slide) => {
            return (_openBlock(), _createBlock(_component_Slide, { key: slide }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "hero-slide-item bg-f",
                  style: _normalizeStyle({
            'background-image': `url(${index.image})`,
          })
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _createElementVNode("span", null, _toDisplayString(index.subTitle), 1),
                          _createElementVNode("h1", null, _toDisplayString(index.heading), 1),
                          _createElementVNode("p", null, _toDisplayString(index.shortDesc), 1),
                          _createElementVNode("div", _hoisted_6, [
                            _cache[3] || (_cache[3] = _createElementVNode("a", {
                              href: "#appointment",
                              class: "btn style2"
                            }, " Book An Appointment ", -1)),
                            _createElementVNode("div", {
                              class: "watch-video",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isPopupMethod(_ctx.isPopup))),
                              style: {"cursor":"pointer"}
                            }, _cache[2] || (_cache[2] = [
                              _createElementVNode("span", { class: "play-btn" }, [
                                _createElementVNode("i", { class: "flaticon-play-1" })
                              ], -1),
                              _createElementVNode("span", { class: "play-text" }, "Watch Our Videos ", -1)
                            ]))
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 4)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    (_ctx.isPopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "popup-overlay-close",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPopupMethod(_ctx.isPopup)))
                }, _cache[4] || (_cache[4] = [
                  _createElementVNode("div", { class: "popup-overlay-close-line" }, null, -1),
                  _createElementVNode("div", { class: "popup-overlay-close-line" }, null, -1)
                ])),
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "play-video" }, [
                  _createElementVNode("iframe", {
                    class: "responsive-iframe",
                    src: "https://www.youtube.com/embed/DublqkOSBBA",
                    allowfullscreen: ""
                  })
                ], -1))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}